import React, { Component } from 'react';
import { Layer } from 'react-konva';
import { connect } from 'react-redux';
import { ICard, RecordState } from '../../redux/types';
import Slot from '../Slot';

type Props = {
  slots: (ICard | null)[];
  listening: boolean;
};

class Slots extends Component<Props> {
  render() {
    const { slots, listening } = this.props;

    return (
      <Layer listening={listening}>
        {slots.map((slot, index) => (
          <Slot card={slot} key={`slot-${index}`} index={index} />
        ))}
      </Layer>
    );
  }
}

function mapStateToProps(state: RecordState) {
  return {
    slots: state.getIn(['gameState', 'slots']),
    listening: state.getIn(['settings', 'listening']),
  };
}

export default connect(mapStateToProps)(Slots);
